import {
  ActionIcon,
  Box,
  Button,
  Center,
  createStyles,
  Menu,
  Paper,
  Table,
  Text,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { NewAddButton } from "../AddButton/NewAddButton";
import { FaPlus } from "react-icons/fa6";
import AddProvider from "../ClaimBilling/AddProvider";
import TableLoader from "../TableLoader";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { IconEdit, IconEye } from "@tabler/icons-react";
import { IconTrash } from "@tabler/icons-react";
import CustomBillingPagination from "../Pagination/CustomBillingPagination";
import { Tooltip } from "recharts";
import {
  getBillingProviderByFacilitId,
  removeProvider,
} from "../../services/billingprovider";
import moment from "moment";
import EditProvider from "../ClaimBilling/AddProvider";
import {
  getProviderServices,
  getServicecode,
} from "../../services/servicecode";
import NoProviderSvg from "../Svgs/NoProviderSvg";

const useStyles = createStyles((theme) => ({
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px",
    borderRadius: "10px",
    background: "#fff",
    marginTop: "10px",
    flexWrap: "wrap",
    gap: "10px",
  },
  tableContainer: {
    padding: "10px",
    borderRadius: "10px",
    background: "#fff",
    marginTop: "20px",
    overflowX: "auto",
  },
  tableRoot: {
    fontFamily: "Inter",
    cursor: "pointer",
    "tbody tr:hover": {
      backgroundColor: "#FFF6ED !important",
    },
  },
  title: {
    color: "#262626",
    textAlign: "center",
    fontFamily: "Inter",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  notFoundTitle: {
    color: "#171717",
    fontFamily: "Inter",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "30px",
  },
  notFoundText: {
    color: "#737373",
    textAlign: "center",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
  header: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: "700",
    color: "#000",
  },
  table: {
    display: "flex",
    flexDirection: "column",
  },
  paperTable: {
    borderRadius: "8px !important",
    border: "1px solid #E5E5E5 !important",
    display: "flex",
    flexDirection: "column",
  },
  bg1: {
    "& td": {
      background: "#fff",
    },
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
  },
  notFoundTextContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "55vh",
    gap: "1rem",
  },
}));

export const ProviderTab = ({ returnedFacility, setActiveTab, mode }) => {
  console.log("returnedFacility", returnedFacility);

  const { classes } = useStyles();
  const [state, setState] = useState({
    addProvider: false,
  });
  const { loading, billingProviderFacility } = useSelector(
    (state) => state.billingprovider
  );

  useEffect(() => {
    getBillingProviderByFacilitId(
      typeof returnedFacility === "object"
        ? returnedFacility?.id
        : returnedFacility,
      currentPage
    );
    getServicecode();
    getProviderServices();
  }, []);

  const [selectedProviders, setSelectedProviders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [manageall, setManageAll] = useState(false);
  const [provideritem, setProvideritem] = useState(null);
  const [editprovider, setEditProvider] = useState(false);
  const [view, setView] = useState(false);

  const handleAddProvider = (stateToSet) => {
    setState({
      addProvider: stateToSet === "addProvider" ? true : false,
    });
  };

  const handleEditProvider = (item, view) => {
    setView(view);
    setProvideritem(item);
    setEditProvider(true);
  };

  const handleRmoveProvider = async (id) => {
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removeProvider({ id, returnedFacility });
  };

  const handlePageChange = async (pageNumber) => {
    setCurrentPage(pageNumber);

    await getBillingProviderByFacilitId(
      typeof returnedFacility === "object"
        ? returnedFacility?.id
        : returnedFacility,
      pageNumber
    );
  };

  const billingList = billingProviderFacility?.billingprovider || [];
  const hasProviders = billingList?.length > 0;

  const renderContent = loading ? (
    <TableLoader />
  ) : hasProviders ? (
    <Box className={classes.table}>
      <Paper className={classes.paperTable} withBorder>
        <Table
          highlightOnHover
          className={classes.tableRoot}
          enableStickyHeader
          fontSize="sm"
          verticalSpacing="md"
        >
          <thead>
            <tr>
              <th>
                <Text className={classes.header}>Provider Name</Text>
              </th>
              <th>
                <Text className={classes.header}>Place of Service Name</Text>
              </th>
              <th>
                <Text className={classes.header}>Created Date</Text>
              </th>
              <th>
                <Text className={classes.header}>Address</Text>
              </th>
              <th>
                <Text className={classes.header}>Actions</Text>
              </th>
            </tr>
          </thead>
          <tbody>
            {billingList?.map((item, index) => {
              const isSelected = selectedProviders.some(
                (provider) => provider.id === item.id
              );

              const handleRowClick = () => {
                if (isSelected) {
                  setSelectedProviders([]);
                } else {
                  setSelectedProviders([item]);
                  setState({ ...state, payer: true, provider: false });
                }
              };

              const handleMenuClick = (event) => {
                event.stopPropagation();
              };

              const bg = index % 2 === 0;
              const providerselected = selectedProviders.some(
                (provider) => provider.id === item?.id
              );

              return (
                <tr
                  key={item?.id}
                  className={
                    providerselected
                      ? classes.selected
                      : bg
                      ? classes.bg2
                      : classes.bg1
                  }
                  onClick={!manageall ? handleRowClick : undefined}
                >
                  <td
                    className={classes.row}
                    onClick={() => handleEditProvider(item, true)}
                  >
                    {item?.name}
                    {(!item?.name ||
                      !item?.address ||
                      !item?.phone ||
                      !item?.zipcode ||
                      !item?.federalTaxID ||
                      !item?.billingIdentifier ||
                      !item?.taxonomy ||
                      !item?.serviceCode ||
                      !item?.state ||
                      !item?.city ||
                      (!item?.services?.length && !manageall)) && (
                      <Tooltip
                        label="Provider Details Incomplete"
                        withArrow
                        position="bottom"
                      >
                        <img
                          width={20}
                          style={{ position: "relative", left: "20px" }}
                          src="/assets/images/error.png"
                          alt="check-icon"
                        />
                      </Tooltip>
                    )}
                  </td>
                  <td
                    className={classes.row}
                    onClick={() => handleEditProvider(item, true)}
                  >
                    {item?.serviceCode?.name || "-"}
                  </td>
                  <td onClick={() => handleEditProvider(item, true)}>
                    <Text ff={"Inter"} fz={"14px"} fw={"600"} color={"#262626"}>
                      {moment(item?.createdAt).format("DD/MM/YYYY") || "-"}
                    </Text>
                  </td>
                  <td
                    className={classes.row}
                    onClick={() => handleEditProvider(item, true)}
                  >
                    {item?.address || "-"}
                  </td>
                  <td onClick={handleMenuClick}>
                    <Menu shadow="md" position="left" zIndex={1000}>
                      <Menu.Target>
                        <ActionIcon>
                          <BiDotsVerticalRounded size={20} color="#000" />
                        </ActionIcon>
                      </Menu.Target>
                      <Menu.Dropdown>
                        <Menu.Item
                          icon={<IconEye size={14} />}
                          onClick={() => handleEditProvider(item, true)}
                        >
                          View
                        </Menu.Item>
                        <Menu.Item
                          icon={<IconEdit size={14} />}
                          onClick={() => handleEditProvider(item, false)}
                        >
                          Edit
                        </Menu.Item>
                        <Menu.Item
                          icon={<IconTrash size={14} />}
                          color="red"
                          onClick={() => handleRmoveProvider(item.id)}
                        >
                          Delete
                        </Menu.Item>
                      </Menu.Dropdown>
                    </Menu>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Paper>
      <Center>
        <CustomBillingPagination
          data={billingProviderFacility.count}
          itemsPerPage={10}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      </Center>
      {mode !== "add" && (
        <Button
          c="#000"
          variant="filled"
          w={150}
          size="md"
          radius="md"
          ml="auto"
          style={{
            backgroundColor: "#FFAF4A",
          }}
          onClick={() => setActiveTab("documents")}
        >
          Next
        </Button>
      )}
    </Box>
  ) : (
    <Box className={classes.notFoundTextContainer}>
      <NoProviderSvg />
      <Text className={classes.notFoundTitle}>Provider</Text>
      <Center>
        <Text className={classes.notFoundText}>
          No Provider has been added to this Facility. Click on the button below
          to add a Provider.
        </Text>
      </Center>
      <NewAddButton
        title="Add Provider"
        onClick={() => handleAddProvider("addProvider")}
        color="#FFAF4A"
        textColor="#000"
        variant="filled"
      />
    </Box>
  );

  return (
    <Box>
      <Box className={classes.headerContainer}>
        <Text className={classes.title}>Provider List</Text>
        <NewAddButton
          title="Add Provider"
          icon={<FaPlus />}
          onClick={() => handleAddProvider("addProvider")}
          color="#FFAF4A"
          textColor="#000"
          variant="filled"
          borderColor="none"
        />
      </Box>
      <Box className={classes.tableContainer}>{renderContent}</Box>
      {/* Add Provider Drawer */}
      <AddProvider
        state={state}
        setState={setState}
        returnedFacility={returnedFacility}
      />
      {/* Edit Provider Drawer */}
      <EditProvider
        editprovider={editprovider}
        setEditProvider={setEditProvider}
        item={provideritem}
        isPreview={view}
        returnedFacility={returnedFacility}
      />
    </Box>
  );
};
